import { render, staticRenderFns } from "./slideInUp.vue?vue&type=template&id=063404a8&"
import script from "./slideInUp.vue?vue&type=script&lang=js&"
export * from "./slideInUp.vue?vue&type=script&lang=js&"
import style0 from "./slideInUp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports